import { createPortal } from 'react-dom'
import type { ReactNode } from 'react'

/**
 * Renders floating select content into document.body when the DOM is available.
 */
export const SelectDropdownPortal = ({ children }: { children: ReactNode }) =>
  typeof document !== 'undefined' ? createPortal(children, document.body) : children

